import React from "react";
import { Mail, Briefcase, Clock } from "lucide-react";
import { LegalPage } from "../components/SiteShell";
import { usePageMeta } from "../lib/usePageMeta";

const CARDS = [
  {
    Icon: Mail,
    label: "Support",
    detail: "Account help, bug reports, feature questions.",
    email: "support@fitnudge.in",
    testid: "contact-card-support",
  },
  {
    Icon: Briefcase,
    label: "Business Inquiries",
    detail: "Partnerships, sales for multi-location gyms, press.",
    email: "hello@fitnudge.in",
    testid: "contact-card-business",
  },
];

export default function Contact() {
  usePageMeta({
    title: "Contact Us",
    description: "Get in touch with Fitnudge - support and business inquiries.",
  });

  return (
    <LegalPage
      testid="contact-page"
      title="Contact Fitnudge"
      subtitle="Need help? We're here to assist."
    >
      <div className="grid sm:grid-cols-2 gap-4">
        {CARDS.map(({ Icon, label, detail, email, testid }) => (
          <a
            key={email}
            href={`mailto:${email}`}
            data-testid={testid}
            className="group block border border-border rounded-2xl p-6 bg-card hover:border-primary/40 hover:shadow-[0_8px_24px_-12px_hsl(var(--primary)/0.35)] transition-all"
          >
            <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
              <Icon className="w-4 h-4 text-primary" strokeWidth={2.4} />
            </div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-muted-foreground mb-1">
              {label}
            </p>
            <p className="text-sm text-foreground/80 mb-3">{detail}</p>
            <p className="font-display text-base font-semibold text-foreground group-hover:text-primary transition-colors">
              {email}
            </p>
          </a>
        ))}
      </div>

      <div className="flex items-start gap-3 p-5 rounded-xl bg-muted/40 border border-border" data-testid="contact-response-time">
        <Clock className="w-4 h-4 text-primary mt-0.5 shrink-0" strokeWidth={2.4} />
        <div>
          <p className="font-semibold text-foreground">Response time</p>
          <p className="text-sm text-muted-foreground mt-1">
            We aim to respond within 1–2 business days. For urgent platform
            issues affecting active classes or check-ins, write "URGENT" in the
            subject line.
          </p>
        </div>
      </div>
    </LegalPage>
  );
}
